import React, { useEffect, useState, useMemo } from "react";
import { Button, Checkbox, Divider, Form, Skeleton, message, Row, Col, ColorPicker } from "antd";
import { SaveButton, InputText, CancelButton, ModalComponent, trans, SelectWithSearch } from "@comps/components"
import { makeRequest, makeRequestStateless, getErrorProps } from "@utils/helpers";
import { getReleatedDataReq, updateDataReq } from "../requests";
import { Commons, Const } from "../../../constants";
import { createSelectList } from '@comps/commonFunctions';
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
const langKey = Const["leaveType"].lngKey
const formName = "createLeaveType";

const UpdateLeaveType = (props) => {
  const [saving, setsaving] = useState(false)
  const [loading, setloading] = useState(true)
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [genders, setGenders] = useState([])
  const [tenures, setTenures] = useState([])
  const [selectedTenureId, setSelectedTenureId] = useState(null);
  const [isComposite, setIscomposite] = useState(false)
  const [isShortLeave, setIsShort] = useState(false)
  const [isSplitable, setSplitable] = useState(false)
  const [isBackDate, setIsBackDate] = useState(false)
  const [isAttach, setIsAttach] = useState(false)
  const [isEncashment, setEncashment] = useState(false)
  const [isCarryForward, setCarryForward] = useState(false)
  const [limitTenureWithin, setLimitTenureWithin] = useState(false)
  const [allLeaveTypes, setAllLeaveTypes] = useState([])
  const [form] = Form.useForm();
  const [deletedCompositeLeaves, setDeletesCompositeLeaves] = useState([])
  const [deletedShortLeaves, setDeletesShortLeaves] = useState([])
  const [initialShortLeave, setInitialShortLeave] = useState([]);
  const [compositeLeaveTypes, setCompositeLeaveTypes] = useState([])
  const [shortLeaveTypes, setShortLeaveTypes] = useState([])
  const [fromDoj, setFromDoj] = useState(false);
  const [taxStructures, setTaxStructures] = useState([]);
  const [fontcolorHex, setFontColorHex] = useState('');
  const [formatHex, setFormatHex] = useState('hex');

  const fontColorHexString = useMemo(
    () => (typeof fontcolorHex === 'string' ? fontcolorHex : fontcolorHex.toHexString()),
    [fontcolorHex],
  );

  const isNonAnnualTenure = selectedTenureId && tenures.find(t => t.value === selectedTenureId)?.label !== 'Annually';

  useEffect(() => {
    getRemoteData();
    setFormData()
    // eslint-disable-next-line
  }, []);

  const getRemoteData = () => {
    makeRequestStateless(getReleatedDataReq, false, onGetRelated, false)
  }
  const onGetRelated = (response) => {
    setGenders(createSelectList([...response.genders, { id: 0, name: 'All' }]))
    setTenures(createSelectList(response.tenures))
    setTaxStructures(createSelectList(response.tax_structures))
    setAllLeaveTypes(createSelectList(response.all_leave_types))
    setloading(false)
  }

  const setFormData = () => {
    if (!props) return
    setCompositeLeaveTypes(props.record.composite_leave_types)
    setShortLeaveTypes(props.record.short_leave_type_slabs)
    setIsShort(props.record.is_short)
    setIscomposite(props.record.is_composite)
    setSplitable(props.record.splitable)
    setIsAttach(props.record.is_attachment_required)
    setEncashment(props.record.encashment)
    setCarryForward(props.record.carry_forward)
    setIsBackDate(props.record.is_back_date_allowed)
    setSelectedTenureId(props.record.tenure_id)
    setInitialShortLeave(props.record.short_leave_type_slabs)
    setFromDoj(props.record.is_from_doj)
    form.setFieldsValue(props.record)
    if (props.record.pre_condition) {
      form.setFieldsValue({
        gender_id: props.record.pre_condition.gender_id ? props.record.pre_condition.gender_id : 0,
        can_apply_in_probation: props.record.pre_condition.can_apply_in_probation,
        min_employee_experience: props.record.pre_condition.min_employee_experience,
        max_applications_in_employment: props.record.pre_condition.max_applications_in_employment,
        gap_between_applications: props.record.pre_condition.gap_between_applications,
        min_days_per_leave: props.record.pre_condition.min_days_per_leave,
        max_days_per_leave: props.record.pre_condition.max_days_per_leave,
        can_apply_for_remaining: props.record.pre_condition.can_apply_for_remaining,
        has_max_limit: props.record.pre_condition.has_max_limit,
        limit_tenure_id: props.record.pre_condition.limit_tenure_id,
        amount_apply_in_tenure: props.record.pre_condition.amount_apply_in_tenure,
      })
    }
  }

  const onSubmit = (data) => {
    data.font_color = fontColorHexString;
    const updatedClt = []
    const updatedSls = []
    if (data.composite_leave_types !== undefined && data.composite_leave_types.length > 0) {
      data.composite_leave_types.forEach(each => {
        each.row_state = each.id === undefined ? 'Added' : 'Updated'
        updatedClt.push(each)
      })
    }
    if (data.short_leave_type_slabs !== undefined && data.short_leave_type_slabs.length > 0) {
      data.short_leave_type_slabs.forEach(each => {
        each.row_state = each.id === undefined ? 'Added' : 'Updated'
        updatedSls.push(each)
      })
    }
    data.composite_leave_types = deletedCompositeLeaves.concat(updatedClt)
    data.short_leave_type_slabs = deletedShortLeaves.concat(updatedSls)
    data.id = props.record.id;
    const payload = {
      leave_type: data,
      pre_condition: {
        gender_id: data.gender_id ? data.gender_id : 0,
        can_apply_in_probation: data.can_apply_in_probation,
        min_employee_experience: data.min_employee_experience,
        max_applications_in_employment: data.max_applications_in_employment,
        gap_between_applications: data.gap_between_applications,
        min_days_per_leave: data.min_days_per_leave,
        max_days_per_leave: data.max_days_per_leave,
        can_apply_for_remaining: data.can_apply_for_remaining,
        has_max_limit: data.has_max_limit,
        limit_tenure_id: data.limit_tenure_id,
        amount_apply_in_tenure: data.amount_apply_in_tenure,
      }
    }
    payload.id = props.record.id;
    makeRequest(setLoader, updateDataReq, payload, onSuccess, onError);
    setsaving(true)
  }

  const onSuccess = (data, res) => {
    setSaveLoader(true)
    message.success("Record Updated");
    props.onCompleted(data.leave_types.data);
  }
  const onError = (err, res) => {
    setsaving(false)
    message.error(res.response.data.message);
  }

  const onDeleteClt = (key, state) => {
    if (compositeLeaveTypes[key] !== undefined && compositeLeaveTypes[key].id !== undefined && state === 'Deleted') {
      compositeLeaveTypes[key].row_state = 'Deleted'
      deletedCompositeLeaves.push(compositeLeaveTypes[key])
    }
  }
  const onDeleteSls = (key, state) => {
    if (compositeLeaveTypes[key] !== undefined && compositeLeaveTypes[key].id !== undefined && state === 'Deleted') {
      compositeLeaveTypes[key].row_state = 'Deleted'
      deletedShortLeaves.push(compositeLeaveTypes[key])
    }
  }

  const footer = [
    !props.disabled && <SaveButton loading={ saving } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  return (
    <ModalComponent top={ 20 } width={ 1300 } maskClosable={ false }
      mainTitle={ trans(Commons[props.disabled ? 'view' : 'update']) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Skeleton loading={ loading }>
        <Form { ...formLayout } form={ form } name={ formName } onFinish={ onSubmit } disabled={ props.disabled } scrollToFirstError>

          {/* ── 1. Basic Information ─────────────────────────────── */}
          <Divider orientation="left">Basic Information</Divider>
          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="name" rules={ rules.name } label={ trans(Commons.name) }
                className="da-mb-16" { ...getErrorProps(errors['name']) } size="small"
                tooltip="Full display name of the leave type (e.g. Annual Leave, Sick Leave)."
              >
                <InputText placeholder={ trans(`${langKey}.name`) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="short_name" rules={ rules.short_name } label={ trans(`${langKey}.short_name`) }
                className="da-mb-16" { ...getErrorProps(errors['short_name']) } size="small"
                tooltip="Short code shown on attendance sheets and calendars (e.g. AL, SL)."
              >
                <InputText placeholder={ trans(`${langKey}.short_name`) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="font_color" label={ trans(`${langKey}.font_color`) }
                className="da-mb-16" { ...getErrorProps(errors['font_color']) } size="small"
                tooltip="Color used to highlight this leave type on calendars and attendance views."
              >
                <ColorPicker format={ formatHex } value={ fontcolorHex }
                  onChange={ setFontColorHex } onFormatChange={ setFormatHex } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_active" label={ trans(`${langKey}.is_active`) }
                className="da-mb-16" { ...getErrorProps(errors['is_active']) } size="small"
                valuePropName="checked"
                tooltip="Inactive leave types are hidden from employees and cannot be applied."
              >
                <Checkbox />
              </Form.Item>
            </Col>
          </Row>

          {/* ── 2. Leave Behavior ────────────────────────────────── */}
          <Divider orientation="left">Leave Behavior</Divider>
          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_composite" label={ trans(`${langKey}.is_composite`) }
                className="da-mb-16" { ...getErrorProps(errors['is_composite']) } size="small"
                valuePropName="checked"
                tooltip="A composite leave pools multiple leave types together. Employees draw from one combined balance instead of applying each type separately."
              >
                <Checkbox onChange={ (e) => setIscomposite(e.target.checked) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_short" label={ trans(`${langKey}.is_short`) }
                className="da-mb-16" { ...getErrorProps(errors['is_short']) } size="small"
                valuePropName="checked"
                tooltip="Enables short-leave slabs (e.g. 2-hour absence = 0.25 day deduction). Use for half-day or hourly leave policies."
              >
                <Checkbox onChange={ (e) => setIsShort(e.target.checked) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="splitable" label={ trans(`${langKey}.splitable`) }
                className="da-mb-16" { ...getErrorProps(errors['splitable']) } size="small"
                valuePropName="checked"
                tooltip="Allow employees to apply partial-day leaves. When enabled, you can set minimum and maximum days per application."
              >
                <Checkbox onChange={ (e) => setSplitable(e.target.checked) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="sandwich" label={ trans(`${langKey}.sandwich`) }
                className="da-mb-16" { ...getErrorProps(errors['sandwich']) } size="small"
                valuePropName="checked"
                tooltip="Sandwich rule: if a leave spans a weekend or holiday, those off-days are counted as leave days too. Example: leave Thu–Mon counts Friday, Saturday, Sunday as leave."
              >
                <Checkbox />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_deductible" label={ trans(`${langKey}.is_deductible`) }
                className="da-mb-16" { ...getErrorProps(errors['is_deductible']) } size="small"
                valuePropName="checked"
                tooltip="When enabled, unapproved or excess leaves of this type are deducted from the employee's salary during payroll."
              >
                <Checkbox />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="quota_deductible" label={ trans(`${langKey}.quota_deductible`) }
                className="da-mb-16" { ...getErrorProps(errors['quota_deductible']) } size="small"
                valuePropName="checked"
                tooltip="Include this leave type when calculating salary deductions for absent days. Disable if this leave should not affect payroll calculations."
              >
                <Checkbox />
              </Form.Item>
            </Col>

            { isSplitable &&
              <>
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="min_days_per_leave" label={ trans(`${langKey}.min_days_per_leave`) }
                    className="da-mb-16" { ...getErrorProps(errors['min_days_per_leave']) } size="small"
                    tooltip="Minimum number of days an employee must apply in one leave request."
                  >
                    <InputText placeholder={ trans(`${langKey}.min_days_per_leave`) } type="number" onWheel={ (e) => e.target.blur() } />
                  </Form.Item>
                </Col>
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="max_days_per_leave" label={ trans(`${langKey}.max_days_per_leave`) }
                    className="da-mb-16" { ...getErrorProps(errors['max_days_per_leave']) } size="small"
                    tooltip="Maximum number of days allowed in a single leave application."
                  >
                    <InputText placeholder={ trans(`${langKey}.max_days_per_leave`) } type="number" onWheel={ (e) => e.target.blur() } />
                  </Form.Item>
                </Col>
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="can_apply_for_remaining" label={ trans(`${langKey}.can_apply_for_remaining`) }
                    className="da-mb-16" { ...getErrorProps(errors['can_apply_for_remaining']) } size="small"
                    valuePropName="checked"
                    tooltip="Allow employees to apply for whatever remaining balance they have, even if it's less than the minimum days."
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="has_max_limit" label={ trans(`${langKey}.has_max_limit`) }
                    className="da-mb-16" { ...getErrorProps(errors['has_max_limit']) } size="small"
                    valuePropName="checked"
                    tooltip="Limit how many days of this leave an employee can apply within a specific time period (e.g. max 3 days per month)."
                  >
                    <Checkbox onChange={ (e) => setLimitTenureWithin(e.target.checked) } />
                  </Form.Item>
                </Col>
                { limitTenureWithin &&
                  <>
                    <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                      <Form.Item name="limit_tenure_id" label={ trans(`${langKey}.limit_tenure_id`) }
                        className="da-mb-16" { ...getErrorProps(errors['limit_tenure_id']) } size="small"
                        tooltip="The time period within which the application limit applies (e.g. Monthly, Quarterly)."
                      >
                        <SelectWithSearch placeholder={ trans(`${langKey}.limit_tenure_id`) } options={ tenures } />
                      </Form.Item>
                    </Col>
                    <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                      <Form.Item name="amount_apply_in_tenure" label={ trans(`${langKey}.amount_apply_in_tenure`) }
                        className="da-mb-16" { ...getErrorProps(errors['amount_apply_in_tenure']) } size="small"
                        tooltip="Maximum number of days the employee can apply within the selected tenure period."
                      >
                        <InputText placeholder={ trans(`${langKey}.amount_apply_in_tenure`) } type="number" onWheel={ (e) => e.target.blur() } />
                      </Form.Item>
                    </Col>
                  </>
                }
              </>
            }
          </Row>

          {/* ── 3. Quota & Balance Settings ──────────────────────── */}
          <Divider orientation="left">Quota &amp; Balance Settings</Divider>
          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="tenure_id" rules={ rules.tenure_id } label={ trans(`${langKey}.tenure_id`) }
                className="da-mb-16" { ...getErrorProps(errors['tenure_id']) } size="small"
                tooltip="How often quota is accrued. Monthly = acc_count leaves earned per month; Annually = full quota assigned once at the start of the fiscal year."
              >
                <SelectWithSearch
                  placeholder={ trans(`${langKey}.tenure_id`) }
                  options={ tenures }
                  onChange={ (val) => setSelectedTenureId(val) }
                />
              </Form.Item>
            </Col>

            { !isComposite &&
              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="acc_count" rules={ rules.acc_count } label={ trans(`${langKey}.acc_count`) }
                  className="da-mb-16" { ...getErrorProps(errors['acc_count']) } size="small"
                  tooltip="Leaves allocated per tenure period. Example: Tenure = Monthly, Count = 2 → employee earns 2 leaves every month (24/year)."
                >
                  <InputText type="number" onWheel={ (e) => e.target.blur() } placeholder={ trans(`${langKey}.acc_count`) } />
                </Form.Item>
              </Col>
            }

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_auto_allotment" label={ trans(`${langKey}.is_auto_allotment`) }
                className="da-mb-16" { ...getErrorProps(errors['is_auto_allotment']) } size="small"
                valuePropName="checked"
                tooltip="Automatically assign quota to employees at the start of each period. If disabled, HR must manually allot quota."
              >
                <Checkbox />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="prorated" label={ trans(`${langKey}.prorated`) }
                className="da-mb-16" { ...getErrorProps(errors['prorated']) } size="small"
                valuePropName="checked"
                tooltip="New joiners get a proportional quota based on their joining date. Example: joins mid-year → gets 6 months' worth instead of the full annual quota."
              >
                <Checkbox />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_from_doj" label={ trans(`${langKey}.balance_on_joining`) }
                className="da-mb-16" { ...getErrorProps(errors['balance_on_joining']) } size="small"
                valuePropName="checked"
                tooltip="Use the employee's joining date as the start of their leave year instead of the company fiscal year. Useful for anniversary-based leave policies."
              >
                <Checkbox onChange={ (e) => setFromDoj(e.target.checked) } />
              </Form.Item>
            </Col>

            { !fromDoj &&
              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="tax_structure_id" label={ trans(`${langKey}.tax_structure_id`) }
                  className="da-mb-16" size="small"
                  tooltip="Link this leave type to a specific fiscal year (tax structure). Leave empty to use the company's default fiscal year."
                >
                  <SelectWithSearch options={ taxStructures } placeholder={ trans(`${langKey}.tax_structure_id`) } />
                </Form.Item>
              </Col>
            }

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="add_earned_quota" label={ trans(`${langKey}.add_earned_quota`) }
                className="da-mb-16" { ...getErrorProps(errors['add_earned_quota']) } size="small"
                valuePropName="checked"
                tooltip="For first-time employees: include the current period's quota on the very first allotment (earned balance). Disable to start from zero."
              >
                <Checkbox />
              </Form.Item>
            </Col>

            { !isComposite &&
              <>
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="is_probation_count" label={ trans(`${langKey}.is_probation_count`) }
                    className="da-mb-16" size="small"
                    valuePropName="checked"
                    tooltip="Use a different (usually lower) quota for employees still on probation."
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="probation_acc_count" label={ trans(`${langKey}.probation_acc_count`) }
                    className="da-mb-16" size="small"
                    tooltip="Quota per tenure period for employees on probation. Only used when 'Is Probation Count' is enabled."
                  >
                    <InputText type="number" onWheel={ (e) => e.target.blur() } placeholder={ trans(`${langKey}.probation_acc_count`) } />
                  </Form.Item>
                </Col>
              </>
            }
          </Row>

          {/* ── 4. Carry Forward ─────────────────────────────────── */}
          <Divider orientation="left">Carry Forward</Divider>
          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="carry_forward" label={ trans(`${langKey}.carry_forward`) }
                className="da-mb-16" { ...getErrorProps(errors['carry_forward']) } size="small"
                valuePropName="checked"
                tooltip="Allow unused leave balance to carry over to the next year. If disabled, unused leaves lapse at year-end."
              >
                <Checkbox onChange={ (e) => setCarryForward(e.target.checked) } />
              </Form.Item>
            </Col>

            { isCarryForward &&
              <>
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="carry_forward_min" label={ trans(`${langKey}.carry_forward_min`) }
                    className="da-mb-16" { ...getErrorProps(errors['carry_forward_min']) } size="small"
                    tooltip="Minimum balance an employee must have to be eligible for carry forward. If remaining balance is below this, nothing carries over."
                  >
                    <InputText placeholder={ trans(`${langKey}.carry_forward_min`) } type="number" onWheel={ (e) => e.target.blur() } />
                  </Form.Item>
                </Col>

                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="carry_forward_max" label={ trans(`${langKey}.carry_forward_max`) }
                    className="da-mb-16" { ...getErrorProps(errors['carry_forward_max']) } size="small"
                    tooltip="Maximum leaves that can be carried to the next year. Any balance above this cap is forfeited."
                  >
                    <InputText placeholder={ trans(`${langKey}.carry_forward_max`) } type="number" onWheel={ (e) => e.target.blur() } />
                  </Form.Item>
                </Col>

                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="carry_forward_years" label={ trans(`${langKey}.carry_forward_years`) }
                    className="da-mb-16" { ...getErrorProps(errors['carry_forward_years']) } size="small"
                    tooltip="How many previous years to look back when calculating the carry-forward balance. Set to 1 to carry only the previous year's balance."
                  >
                    <InputText placeholder={ trans(`${langKey}.carry_forward_years`) } type="number" onWheel={ (e) => e.target.blur() } />
                  </Form.Item>
                </Col>

                { isNonAnnualTenure &&
                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name="carry_forward_months" label={ trans(`${langKey}.carry_forward_months`) }
                      className="da-mb-16" { ...getErrorProps(errors['carry_forward_months']) } size="small"
                      tooltip="Maximum number of periods worth of quota that can accumulate at once. Example: Monthly leave with limit 3 means no more than 3 months' quota can stack — older unused leaves lapse. Leave empty for unlimited accumulation."
                    >
                      <InputText placeholder={ trans(`${langKey}.carry_forward_months`) } type="number" onWheel={ (e) => e.target.blur() } />
                    </Form.Item>
                  </Col>
                }
              </>
            }
          </Row>

          {/* ── 5. Encashment ────────────────────────────────────── */}
          <Divider orientation="left">Encashment</Divider>
          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="encashment" label={ trans(`${langKey}.encashment`) }
                className="da-mb-16" { ...getErrorProps(errors['encashment']) } size="small"
                valuePropName="checked"
                tooltip="Allow employees to convert unused leave balance into cash payment instead of carrying it forward."
              >
                <Checkbox onChange={ (e) => setEncashment(e.target.checked) } />
              </Form.Item>
            </Col>

            { isEncashment &&
              <>
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="encashment_min" label={ trans(`${langKey}.encashment_min`) }
                    className="da-mb-16" { ...getErrorProps(errors['encashment_min']) } size="small"
                    tooltip="Minimum leave balance required before an employee can encash. Below this threshold, encashment is not allowed."
                  >
                    <InputText placeholder={ trans(`${langKey}.encashment_min`) } type="number" onWheel={ (e) => e.target.blur() } />
                  </Form.Item>
                </Col>

                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="encashment_max" label={ trans(`${langKey}.encashment_max`) }
                    className="da-mb-16" { ...getErrorProps(errors['encashment_max']) } size="small"
                    tooltip="Maximum number of leaves that can be encashed. Any balance above this cap cannot be converted to cash."
                  >
                    <InputText placeholder={ trans(`${langKey}.encashment_max`) } type="number" onWheel={ (e) => e.target.blur() } />
                  </Form.Item>
                </Col>
              </>
            }
          </Row>

          {/* ── 6. Application Rules ─────────────────────────────── */}
          <Divider orientation="left">Application Rules</Divider>
          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_back_date_allowed" label={ trans(`${langKey}.is_back_date_allowed`) }
                className="da-mb-16" { ...getErrorProps(errors['is_back_date_allowed']) } size="small"
                valuePropName="checked"
                tooltip="Allow employees to apply for leave with a past start date. Useful for emergency or retroactive leave applications."
              >
                <Checkbox onChange={ (e) => setIsBackDate(e.target.checked) } />
              </Form.Item>
            </Col>

            { isBackDate &&
              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="days_back_date_allowed" label={ trans(`${langKey}.days_back_date_allowed`) }
                  className="da-mb-16" { ...getErrorProps(errors['days_back_date_allowed']) } size="small"
                  tooltip="How many days in the past an employee can backdate a leave application. Example: 7 means they can apply for leave up to 7 days ago."
                >
                  <InputText placeholder={ trans(`${langKey}.days_back_date_allowed`) } type="number" onWheel={ (e) => e.target.blur() } />
                </Form.Item>
              </Col>
            }

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_attachment_required" label={ trans(`${langKey}.is_attachment_required`) }
                className="da-mb-16" { ...getErrorProps(errors['is_attachment_required']) } size="small"
                valuePropName="checked"
                tooltip="Require employees to upload a supporting document (e.g. medical certificate) when applying for this leave type."
              >
                <Checkbox onChange={ (e) => setIsAttach(e.target.checked) } />
              </Form.Item>
            </Col>

            { isAttach &&
              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="days_attachment_required" label={ trans(`${langKey}.days_attachment_required`) }
                  className="da-mb-16" { ...getErrorProps(errors['days_attachment_required']) } size="small"
                  tooltip="Attachment is only required if the leave duration exceeds this number of days. Example: 2 means documents needed only for leaves longer than 2 days."
                >
                  <InputText placeholder={ trans(`${langKey}.days_attachment_required`) } type="number" onWheel={ (e) => e.target.blur() } />
                </Form.Item>
              </Col>
            }
          </Row>

          {/* ── 7. Pre-Conditions ────────────────────────────────── */}
          <Divider orientation="left">Pre-Conditions</Divider>
          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="gender_id" rules={ rules.gender_id } label={ trans(`${langKey}.gender_id`) }
                className="da-mb-16" { ...getErrorProps(errors['gender_id']) } size="small"
                tooltip="Restrict this leave type to a specific gender. Select 'All' to make it available to everyone."
              >
                <SelectWithSearch defaultValue={ 0 } placeholder={ trans(`${langKey}.gender_id`) } options={ genders } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="can_apply_in_probation" label={ trans(`${langKey}.can_apply_in_probation`) }
                className="da-mb-16" { ...getErrorProps(errors['can_apply_in_probation']) } size="small"
                valuePropName="checked"
                tooltip="Allow employees on probation to apply for this leave. Disable to restrict it to confirmed employees only."
              >
                <Checkbox />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="min_employee_experience" label={ trans(`${langKey}.min_employee_experience`) }
                className="da-mb-16" { ...getErrorProps(errors['min_employee_experience']) } size="small"
                tooltip="Minimum months of service required before an employee can apply for this leave. Example: 6 means the employee must have worked at least 6 months."
              >
                <InputText type="number" onWheel={ (e) => e.target.blur() } placeholder={ trans(`${langKey}.min_employee_experience`) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="max_applications_in_employment" label={ trans(`${langKey}.max_applications_in_employment`) }
                className="da-mb-16" { ...getErrorProps(errors['max_applications_in_employment']) } size="small"
                tooltip="Total number of times an employee can apply for this leave during their entire employment. Leave empty for no limit."
              >
                <InputText type="number" onWheel={ (e) => e.target.blur() } placeholder={ trans(`${langKey}.max_applications_in_employment`) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="gap_between_applications" label={ trans(`${langKey}.gap_between_applications`) }
                className="da-mb-16" { ...getErrorProps(errors['gap_between_applications']) } size="small"
                tooltip="Minimum gap (in months) required between two consecutive applications of this leave type. Example: 3 means the employee must wait 3 months before applying again."
              >
                <InputText type="number" onWheel={ (e) => e.target.blur() } placeholder={ trans(`${langKey}.gap_between_applications`) } />
              </Form.Item>
            </Col>
          </Row>

          {/* ── Composite Leave Settings ─────────────────────────── */}
          { isComposite &&
            <div className="formlist-container">
              <h5 className="formlist-title">Composite Leave Settings</h5>
              <Form.List name="composite_leave_types">
                { (fields, { add, remove }) => (
                  <>
                    <Button onClick={ () => add() } icon={ <PlusOutlined /> } type="primary" className="add-node-button">Add</Button>
                    <div className="table-container">
                      <table className="table">
                        { fields.length !== 0 &&
                          <thead>
                            <tr>
                              <th style={ { paddingLeft: 20 } }>{ trans(`${langKey}.leave_type_id`) }</th>
                              <th>{ trans(Commons.actions) }</th>
                            </tr>
                          </thead>
                        }
                        <tbody>
                          { fields.map(({ key, name, ...restField }) => (
                            <tr key={ key }>
                              <td style={ { minWidth: '200px', paddingLeft: 20 } }>
                                <Form.Item { ...restField } name={ [name, 'leave_type_id'] } rules={ rules.leave_type_id }>
                                  <SelectWithSearch options={ allLeaveTypes } placeholder={ trans(`${langKey}.leave_type_id`) } />
                                </Form.Item>
                              </td>
                              <td>
                                <DeleteOutlined className="formlist-remove" onClick={ () => { remove(name); onDeleteClt(key, 'Deleted') } } />
                              </td>
                            </tr>
                          )) }
                        </tbody>
                      </table>
                    </div>
                  </>
                ) }
              </Form.List>
            </div>
          }

          {/* ── Short Leave Slabs ────────────────────────────────── */}
          { isShortLeave &&
            <div className="formlist-container">
              <h5 className="formlist-title">Short Leave Slabs</h5>
              <Form.List name="short_leave_type_slabs">
                { (fields, { add, remove }) => (
                  <>
                    <Button onClick={ () => add() } icon={ <PlusOutlined /> } type="primary" className="add-node-button">Add</Button>
                    <div className="table-container">
                      <table className="table">
                        { fields.length !== 0 &&
                          <thead>
                            <tr>
                              <th style={ { paddingLeft: 20 } }>{ trans(`${langKey}.leave_type_id`) }</th>
                              <th>{ trans(`${langKey}.quota`) }</th>
                              <th>{ trans(`${langKey}.type`) }</th>
                              <th>{ trans(`${langKey}.value`) }</th>
                              <th>{ trans(Commons.actions) }</th>
                            </tr>
                          </thead>
                        }
                        <tbody>
                          { fields.map(({ key, name, ...restField }) => (
                            <tr key={ key }>
                              <td style={ { minWidth: '200px', paddingLeft: 20 } }>
                                <Form.Item { ...restField } name={ [name, 'name'] } rules={ rules.name }>
                                  <InputText placeholder={ trans(`${langKey}.name`) } />
                                </Form.Item>
                              </td>
                              <td style={ { minWidth: '200px' } }>
                                <Form.Item { ...restField } name={ [name, 'quota'] } rules={ rules.quota }>
                                  <InputText placeholder={ trans(`${langKey}.Balance`) } type="number" onWheel={ (e) => e.target.blur() } />
                                </Form.Item>
                              </td>
                              <td style={ { minWidth: '200px' } }>
                                <Form.Item { ...restField } name={ [name, 'type'] } rules={ rules.type }>
                                  <SelectWithSearch options={ [{ label: 'Percentage', value: 'percentage' }, { label: 'Flat', value: 'flat' }] } placeholder={ trans(`${langKey}.type`) } />
                                </Form.Item>
                              </td>
                              <td style={ { minWidth: '200px' } }>
                                <Form.Item { ...restField } name={ [name, 'value'] } rules={ rules.value }>
                                  <InputText placeholder={ trans(`${langKey}.value`) } type="number" onWheel={ (e) => e.target.blur() } />
                                </Form.Item>
                              </td>
                              <td>
                                <DeleteOutlined className="formlist-remove" onClick={ () => { remove(name); onDeleteSls(key, 'Deleted') } } />
                              </td>
                            </tr>
                          )) }
                        </tbody>
                      </table>
                    </div>
                  </>
                ) }
              </Form.List>
            </div>
          }

        </Form>
      </Skeleton>
    </ModalComponent>
  )
}

export default UpdateLeaveType

const rules = {
  name: [{ required: true, message: trans(`${langKey}.name`) }],
  short_name: [{ required: true, message: trans(`${langKey}.short_name`) }],
  gender_id: [{ required: true, message: trans(`${langKey}.gender_id`) }],
  tenure_id: [{ required: true, message: trans(`${langKey}.tenure_id`) }],
  acc_count: [{ required: true, message: trans(`${langKey}.acc_count`) }],
  leave_type_id: [{ required: true, message: trans(`${langKey}.leave_type_id`) }],
  quota: [{ required: true, message: trans(`${langKey}.quota`) }],
  type: [{ required: true, message: trans(`${langKey}.type`) }],
  value: [{ required: true, message: trans(`${langKey}.value`) }],
};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
